var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Variable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M42,13c0,0.553-0.447,1-1,1H7c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1h34c0.553,0,1,0.447,1,1V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M6 11H42V42H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M13.102 25.907c0-1.154.141-2.262.421-3.324.281-1.062.701-2.01 1.26-2.848.559-.837 1.156-1.415 1.793-1.735L17 19.206c-.604.546-1.083 1.385-1.436 2.516-.354 1.132-.538 2.438-.554 3.923v.464c0 1.546.176 2.905.525 4.077S16.374 32.233 17 32.81L16.575 34c-.631-.319-1.224-.889-1.777-1.708s-.972-1.752-1.255-2.798c-.284-1.046-.431-2.137-.441-3.271V25.907zM23.996 24.777L25.809 21h3.119l-3.166 5.454L29 32h-3.154l-1.85-3.846L22.155 32H19l3.239-5.546L19.065 21h3.118L23.996 24.777zM35 26.093c0 1.201-.159 2.338-.478 3.408-.317 1.072-.759 2.014-1.323 2.822-.564.808-1.162 1.367-1.793 1.677l-.417-1.19c.609-.562 1.091-1.421 1.444-2.577.353-1.157.534-2.467.545-3.932v-.409c0-1.499-.176-2.841-.525-4.022-.35-1.183-.838-2.075-1.464-2.679L31.406 18c.412.201.833.536 1.264 1.005.43.468.819 1.048 1.167 1.739.348.69.629 1.468.842 2.331C34.893 23.938 35 24.943 35 26.093z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Variable);
export default __webpack_public_path__ + "static/media/icons8-variable.89156e0c68d04dd0b9152c0d64d6d316.svg";
export { ForwardRef as ReactComponent };